import React, { useEffect, useRef, useState } from "react";
import { CheckPicker, Col, InputNumber, Row, SelectPicker } from "rsuite";
import { getPricingFilters } from "../../queries/apiQueries";
import { useLocation } from "react-router-dom";

const Filters = (props: any) => {
  const [filterData, setFilterData] = useState<any>(null);
  const [fromTo, setFromTo] = useState({ from: 0, to: 0 })
  const [selectedFilter, setSelectedFilter] = useState<any>({ Description: [], peerGroupName: [], bill_customer_id: [], division: [], itemid: [], projectFlag: ['NonProject'], userEmail: localStorage.getItem('user_email') })

  const didMount = useRef(false);
  const didClean = useRef(false);
  const location = useLocation()
  const customer = new URLSearchParams(location.search).get("customer");
  const getPricingFilterData = () => {
    getPricingFilters(selectedFilter)
      .then((response: any) => {
        if (response?.status === 200) {
          response?.data?.bill_customer_id.forEach((value: any) => {
            value.label = `${value?.bill_customer_id} - ${value?.customerDesc}`
          })

          setFilterData(response?.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getPricingFilterData();
  }, []);

  useEffect(() => {
    if (props.data?.list?.length > 0) {
      if ((fromTo.from == 0 || fromTo.from == undefined) && (fromTo.to == 0 || fromTo.to == undefined)) {
        setFromTo({ from: props?.data?.minOpp, to: props?.data?.maxOpp })
      }
    }
  }, [props.data?.list, fromTo])

  useEffect(() => {
    if (didClean.current) {
      getPricingFilterData()
      props.handleFilterChange(selectedFilter)
      didClean.current = false
    }

  }, [selectedFilter])

  const handleSelectedFilter = () => {
    if (didMount.current) {
      getPricingFilterData()
      props.handleFilterChange(selectedFilter)
      didMount.current = false
    }
  }


  useEffect(() => {
    if (customer) {
      setSelectedFilter({ ...selectedFilter, bill_customer_id: [customer] })
      didClean.current = true
    }

  }, [customer])





  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Row className="show-grid" style={{ width: "93%" }}>
        <Col xs={2}>
          <p
            className="filterHead"
          >
            Project Type
          </p>
          <SelectPicker
            onExit={handleSelectedFilter}
            cleanable={false}
            // onClean={() => didClean.current = true}
            preventOverflow={true}
            appearance="default"
            size="xs"
            onChange={(value: any) => { setSelectedFilter({ ...selectedFilter, projectFlag: value ? [value] : [], itemid: [], division: [], Description: [], peerGroupName: [], bill_customer_id: [] }), didMount.current = true }}
            menuStyle={{
              background: "gray",
              color: "white",
              width: "auto",
              fontSize: "1em",
            }}
            placeholder="All"
            data={filterData?.projectFlag}
            labelKey="project_flag"
            valueKey="project_flag"
            style={{ width: "100%", background: "gray", color: "white" }}
            value={selectedFilter?.projectFlag[0]}
          />
        </Col>
        <Col xs={2}>
          <p
            className="filterHead"
          >
            District
          </p>
          <CheckPicker
            onExit={handleSelectedFilter}
            onClean={() => didClean.current = true}

            preventOverflow={true}
            appearance="default"
            size="xs"
            onChange={(value: any) => { setSelectedFilter({ ...selectedFilter, division: value }), didMount.current = true }}
            menuStyle={{
              background: "gray",
              color: "white",
              width: "auto",
              fontSize: "1em",
            }}
            placeholder="All"
            data={filterData?.division}
            labelKey="plant"
            valueKey="plant"
            style={{ width: "100%", background: "gray", color: "white" }}
            value={selectedFilter?.division}
          />
        </Col>
        <Col xs={2}>
          <p
            className="filterHead"
          >
            Peer Group
          </p>
          <CheckPicker
            onExit={handleSelectedFilter}
            onClean={() => didClean.current = true}
            preventOverflow={true}
            appearance="default"
            size="xs"
            onChange={(value: any) => { setSelectedFilter({ ...selectedFilter, peerGroupName: value }), didMount.current = true }}
            menuStyle={{
              background: "gray",
              color: "white",
              width: "auto",
              fontSize: "1em",
            }}
            placeholder="All"
            data={filterData?.peerGroupName}
            labelKey="peerGroupName"
            valueKey="peerGroupName"
            style={{ width: "100%", background: "gray", color: "white" }}
            value={selectedFilter?.peerGroupName}
          />
        </Col>
        <Col xs={2}>
          <p
            className="filterHead"
          >
            Customer
          </p>
          <CheckPicker
            onExit={handleSelectedFilter}
            onClean={() => didClean.current = true}
            preventOverflow={true}
            appearance="default"
            size="xs"
            onChange={(value: any) => { setSelectedFilter({ ...selectedFilter, bill_customer_id: value }), didMount.current = true }}
            menuStyle={{
              background: "gray",
              color: "white",
              width: "auto",
              fontSize: "1em",
            }}
            placeholder="All"
            data={filterData?.bill_customer_id}
            labelKey="label"
            valueKey="bill_customer_id"
            value={selectedFilter?.bill_customer_id}
            style={{ width: "100%", background: "gray", color: "white" }}
          />
        </Col>
        <Col xs={2}>
          <p
            className="filterHead"
          >
            Item ID
          </p>
          <CheckPicker
            onExit={handleSelectedFilter}
            onClean={() => didClean.current = true}
            preventOverflow={true}
            appearance="default"
            size="xs"
            onChange={(value: any) => { setSelectedFilter({ ...selectedFilter, itemid: value }), didMount.current = true }}
            menuStyle={{
              background: "gray",
              color: "white",
              width: "auto",
              fontSize: "1em",
            }}
            placeholder="All"
            data={filterData?.itemid}
            labelKey="cluster"
            valueKey="cluster"
            // defaultValue={item.default ? item.default : null}
            // value={item.default ? item.default : null}

            style={{ width: "100%", background: "gray", color: "white" }}
            value={selectedFilter?.itemid}
          />
        </Col>
        <Col xs={2}>
          <p
            className="filterHead"
          >
            Item Description
          </p>
          <CheckPicker
            onExit={handleSelectedFilter}
            onClean={() => didClean.current = true}
            preventOverflow={true}
            appearance="default"
            size="xs"
            onChange={(value: any) => { setSelectedFilter({ ...selectedFilter, Description: value }), didMount.current = true }}
            menuStyle={{
              background: "gray",
              color: "white",
              width: "auto",
              fontSize: "1em",
            }}
            placeholder="All"
            data={filterData?.Description}
            labelKey="Description"
            valueKey="Description"
            style={{ width: "100%", background: "gray", color: "white" }}
            value={selectedFilter?.Description}
          />
        </Col>

        {/* PROJECT FILTER */}
        {/* <Col xs={3}>
          <p
            className="filterHead"
          >
            Project Type
          </p>
          <SelectPicker
            onExit={handleSelectedFilter}
            onClean={() => didClean.current = true}
            searchable={false}
            preventOverflow={true}
            appearance="default"
            size="xs"
            onChange={(value: any) => { setSelectedFilter({ ...selectedFilter, projectFlag: value }), didMount.current = true }}
            menuStyle={{
              background: "gray",
              color: "white",
              width: "auto",
              fontSize: "1em",
            }}
            placeholder="All"
            data={[{ projectType: "Project" }, { projectType: "NonProject" }]}
            labelKey="projectType"
            valueKey="projectType"
            style={{ width: "100%", background: "gray", color: "white" }}
          />
        </Col> */}

        <Col
          xs={3}></Col>
        <Col
          xs={2}></Col>
        <Col
          xs={2}
          className="filterHead"
          style={{ marginTop: 25, left: 30 }}
        >
          Opportunity
        </Col>
        <Col
          xs={2}
          className="filterHead"
        >
          From <InputNumber value={fromTo.from} onChange={($: any) => setFromTo({ ...fromTo, from: $ })} size="sm" />
        </Col>
        <Col
          xs={2}
          className="filterHead"
        >
          To <InputNumber value={fromTo.to} onChange={($: any) => setFromTo({ ...fromTo, to: $ })} size="sm" />
        </Col>
        <Col xs={1}>
          <button
            className="slider_cta"
            onClick={() => {
              props.handleSliderAPI([fromTo.from, fromTo.to, selectedFilter])}}
          >
            Go
          </button>
        </Col>
      </Row>
    </div>
  );
};

export default Filters;
